import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-premier',
  templateUrl: './premier.component.html',
  styleUrls: ['./premier.component.scss']
})
export class PremierComponent {
  constructor(private dialogRef: MatDialogRef<PremierComponent>) {}

  close() {
    this.dialogRef.close();
  }
}
